export default "/assets/images/rookie-parent-crop.ea1227a8fc3b02cf.png";